import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { MascotId } from "../constants/mascotCatalog";

interface MascotState {
    selectedMascotId: MascotId | null;
    selectMascot: (id: MascotId) => void;
};

export const useMascotStore = create<MascotState>()(
    persist(
        (set) => ({
            selectedMascotId: null,
            selectMascot: (id) => set({ selectedMascotId: id }),
        }),
        {
            name: 'mascot-selection',
            partialize: (state) => ({
                selectedMascotId: state.selectedMascotId
            })
        }
    )
);

export const useSelectedMascotId = () =>
    useMascotStore((s) => s.selectedMascotId);

export const useMascotActions = () =>
    useMascotStore((s) => s.selectMascot);